import fsmMakePick from '../fsm/make_pick';

const search = () => {
  if (fsmMakePick.is('completed')) {
    $('@toggleSlideTrigger').fadeOut();
    if ($('@makePickSearch').is(':visible')) {
      $('@toggleSlideTrigger').trigger('click');
      $('a[href*="#clear"]').trigger('click');
    }
    return;
  }
  $('@toggleSlideTrigger').fadeIn();
};

export default search;
